/* eslint-disable import/no-anonymous-default-export */
export default (post = [], action) => {
    switch (action.type) {
        case 'GET_POST':
            return action.payload;
        default:
            return post;
    }
}